// extracted by mini-css-extract-plugin
export default {"formItem":"modals_formItem__ggEvu"};